export function loadRelatedStories(story) {
  const FIELDS = "id,metadata,story-template,headline,slug,hero-image-s3-key,hero-image-metadata,author-name,author-id,authors";
  const sectionQuery = story.sections && story.sections.length !== 0 ? `section-id=${story.sections[0].id}` : '';   
  
  return fetch(`/api/v1/stories/${story.id}/related-stories?${sectionQuery}&fields=${FIELDS}`)
    .then(relatedStories => relatedStories.json())
    .then(relatedStories => relatedStories['related-stories'])
    .catch(err => {
      console.error('Error in retrieving related stories :', err);
      return [];
    });
}